// src/config/site.config.ts

import { LAYOUT_OPTIONS } from './enums';

enum MODE {
  DARK = 'dark',
  LIGHT = 'light',
}

export const siteConfig = {
  title: 'OwoHQ Super Admin Dashboard',
  description: 'OwoHQ Super Admin Dashboard',
  // In Vite/CRA, put your SVGs in /public and reference by path:
  logo: '/logo.svg',
  icon: '/logo-short.svg',
  mode: MODE.LIGHT,
  layout: LAYOUT_OPTIONS.HYDROGEN,
};

// Simple meta‑object generator (you can feed this into react-helmet, react-helmet-async, etc.)
export function metaObject(
  pageTitle?: string,
  description: string = siteConfig.description,
  openGraph?: {
    title?: string;
    description?: string;
    url?: string;
    siteName?: string;
    images?: { url: string; width: number; height: number }[];
    locale?: string;
    type?: string;
  }
) {
  const title = pageTitle ? `${pageTitle} | ${siteConfig.title}` : siteConfig.title;

  return {
    title,
    description,
    openGraph: openGraph ?? {
      title,
      description,
      url: window?.location?.origin || '',
      siteName: siteConfig.title,
      images: [
        { url: 'https://i.ibb.co/XrYbG2h6/OWO-ICON-3.png', width: 1200, height: 630 }
      ],
      locale: 'en_US',
      type: 'website',
    },
  };
}
